import React from "react";
import Lottie from "react-lottie-player";
import animationData from "../../../Assets/svgs/PageLoading.json";
const PageLoading = () => {
  return (
    <div
      style={{
        position: "absolute",
        top: "0",
        bottom: "0",
        right: "0",
        left: "0",
      }}
    >
      <Lottie
        loop
        animationData={animationData}
        play
        style={{
          height: "100%",
        }}
      />
    </div>
  );
};

export default PageLoading;
